import { DetailsList, Selection, SelectionMode } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import { MyContext } from '../../../context';
import Utils from '../../common/Utils'

const orderAlphabetically  = Utils.orderAlphabetically


export default class AIAdherencePhrasesListView extends Component {
    static contextType = MyContext
    _selection: Selection;

    constructor(props) {
        super(props);
        this._selection = new Selection({
            onSelectionChanged: () => {
                this.props.selectPhrase(this._selection.getSelection().length > 0 ? this._selection.getSelection()[0].id : null)
            }
        });
    }

    getKey = (item, index) => {
        return item.key;
    }

    renderItemColumn = (item, index, column) => {
        const fieldContent = item[column.fieldName]
        switch (column.key) {
            case 'adherence':
                return <span>{fieldContent}%</span>;
            case 'contained': {
                if (item.adherence !== 0 && item.adherence !== 100) {
                    return (
                        <span>
                            {
                                (fieldContent ?
                                    this.context.getTranslation("compliance", "exceeded") :
                                    this.context.getTranslation("compliance", "fallenBelow"))
                            }
                        </span>
                    )
                } else { return (<span></span>) }
            }
            default:
                return <span>{fieldContent !== null ? fieldContent : ""}</span>;
        }
    }

    render() {
        const columns = [
            { key: 'name', name: this.context.getTranslation("compliance", "detailPolicyName"), fieldName: 'name', minWidth: 100, maxWidth: 200, isResizable: true },
            { key: 'description', name: this.context.getTranslation("compliance", "detailPolicyDescription"), fieldName: 'description', minWidth: 100, maxWidth: 200 },
            { key: 'phrase', name: this.context.getTranslation("compliance", "phrase"), fieldName: 'phrase', minWidth: 100, maxWidth: 200 },
            {
                key: 'relatedPhrases',
                name: this.context.getTranslation("compliance", "relatedPhrases"),
                fieldName: 'relatedPhrases',
                minWidth: 300,
                maxWidth: 600,
                isResizable: true,
                onRender: (item: IDocument) => {
                    return item.relatedPhrases.join("; ")
                }
            },
            {
                key: 'unrelatedPhrases',
                name: this.context.getTranslation("compliance", "unrelatedPhrases"),
                fieldName: 'unrelatedPhrases',
                minWidth: 300,
                maxWidth: 600,
                isResizable: true,
                onRender: (item: IDocument) => {
                    return item.unrelatedPhrases.join("; ")
                }
            },
        ]
        return (
            <DetailsList
                items={this.props.phrases.sort((a,b)=>orderAlphabetically.call(null,a.name.toLowerCase(),b.name.toLowerCase()))}
                columns={columns}
                selectionMode={SelectionMode.single}
                selection={this._selection}
                getKey={this.getKey}
                setKey="single"
                onRenderItemColumn={this.renderItemColumn}
            />
        );
    }
}